import { createSelector } from 'reselect';

export const instancesSelector = (state) => state.get('instances');

export const instancesByIdSelector = createSelector(
  instancesSelector,
  (instances) => instances.get('byId')
);

export const instancesAllIdsSelector = createSelector(
  instancesSelector,
  (instances) => instances.get('allIds')
);

export const instancesByProjectIdSelector = createSelector(
  instancesSelector,
  (instances) => instances.get('byProjectId')
);
